var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntegrationTextIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 1H13.6001V2.2H2.2V20.2185H22.1517L19.3575 17.4244C19.1232 17.1901 19.1232 16.8102 19.3575 16.5759C19.5919 16.3416 19.9718 16.3416 20.2061 16.5759L24.0244 20.3942C24.2588 20.6286 24.2588 21.0085 24.0244 21.2428L20.2061 25.0611C19.9718 25.2955 19.5919 25.2955 19.3575 25.0611C19.1232 24.8268 19.1232 24.4469 19.3575 24.2126L22.1517 21.4185H1V1Z",
    fill: "#F1F1F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.1992 31.5332H17.5991V30.3332H28.9992L28.9992 12.3147L9.04756 12.3147L11.8417 15.1088C12.076 15.3431 12.076 15.723 11.8417 15.9573C11.6074 16.1916 11.2275 16.1916 10.9931 15.9573L7.17477 12.139C6.94046 11.9046 6.94046 11.5247 7.17477 11.2904L10.9931 7.47205C11.2275 7.23774 11.6074 7.23774 11.8417 7.47205C12.076 7.70637 12.076 8.08627 11.8417 8.32058L9.04756 11.1147L30.1992 11.1147L30.1992 31.5332Z",
    fill: "#F1F1F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationTextIcon);
export default __webpack_public_path__ + "static/media/integration-text-icon.7c790bf5.svg";
export { ForwardRef as ReactComponent };